import {observable, action, computed} from 'mobx'
import {getNoticeInfo} from '@/services/CloseDown'
import log from "@/utils/log";

export default class CloseDown {
  @observable private showCloseDown: boolean = false; // 显示公告
  @observable msg: string = '' // 公告信息
  @observable alreadyShowCloseDown: boolean = false; // 已经显示过

  @computed get getShowCloseDown ():boolean {
    return this.showCloseDown
  }

  @action.bound
  async getnNoticeInfo() {
    if(this.alreadyShowCloseDown) return ;

    const [error, result] = await getNoticeInfo()
    if(error) return;
    this.msg = result.text_value
    this.setShowCloseDown(true)
    log({eventId: 'E2200', pageId: 'P22', ext: ''})
  }

  @action.bound
  async setShowCloseDown(bool:boolean) {
    if(this.showCloseDown && !bool) this.alreadyShowCloseDown = true;

    this.showCloseDown = bool;
  }
}
